import {
  validateEvidenceLabConfig,
  type EvidenceLabConfig,
} from '../minigames/evidence-lab/EvidenceLabConfig.js';

export const LIFE_CYCLE_INVESTIGATION: EvidenceLabConfig = {
  id: 'frog-life-cycle-1',
  skillId: 'science-life-cycles-1',
  question: 'Which sequence shows how a frog changes through its life cycle?',
  subjects: [
    {
      id: 'eggs',
      label: 'POND EGGS',
      observation: 'Many round eggs rest together in clear jelly near the water plants.',
      evidenceId: 'eggs-first-stage',
    },
    {
      id: 'tadpole',
      label: 'TADPOLE',
      observation: 'A tadpole swims with a long tail and has no legs yet.',
      evidenceId: 'tadpole-after-eggs',
    },
    {
      id: 'froglet',
      label: 'FROGLET',
      observation: 'A froglet has growing legs while a short tail is still visible.',
      evidenceId: 'froglet-after-tadpole',
    },
    {
      id: 'adult-frog',
      label: 'ADULT FROG',
      observation: 'An adult frog has four legs and can return to the pond to lay eggs.',
      evidenceId: 'adult-completes-cycle',
    },
  ],
  conclusions: [
    { id: 'eggs-tadpole-froglet-adult', text: 'Eggs → tadpole → froglet → adult frog' },
    { id: 'eggs-froglet-tadpole-adult', text: 'Eggs → froglet → tadpole → adult frog' },
    { id: 'adult-eggs-froglet-tadpole', text: 'Adult frog → eggs → froglet → tadpole' },
  ],
  correctConclusionId: 'eggs-tadpole-froglet-adult',
  requiredEvidenceIds: [
    'eggs-first-stage',
    'tadpole-after-eggs',
    'froglet-after-tadpole',
    'adult-completes-cycle',
  ],
  hints: [
    'Record what body parts you observe at every pond station.',
    'The swimming stage without legs comes before the stage with legs and a tail.',
    'Begin with eggs, then follow the tadpole as legs grow and the tail becomes shorter.',
  ],
  evidenceExplanation:
    'The records show eggs hatch into tadpoles, tadpoles grow legs into froglets, and froglets become adult frogs.',
  successMessage: 'The pond lantern glows and the whole frog life cycle appears!',
  restorationEvent: 'life-cycle-pond-restored',
};

validateEvidenceLabConfig(LIFE_CYCLE_INVESTIGATION);
